import { render, staticRenderFns } from "./FormSubmitDiscard.vue?vue&type=template&id=37ca6c4b&"
import script from "./FormSubmitDiscard.vue?vue&type=script&lang=js&"
export * from "./FormSubmitDiscard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports